import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { Heading, Button, Markdown, SanityImage } from '../elements';

const Section = styled.section`
  background-color: ${(props) => props.theme.backgroundColorLight};
`;

const HowWeWork = ({ heading, howWeWork = {} }) => {
  return (
    <Section className="section">
      <div className="container">
        {heading && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown className="pb-2 has-text-grey-dark">{heading}</Markdown>
            </div>
          </div>
        )}
        <div className="columns is-variable is-8 is-vcentered">
          <div className="column is-6">
            {howWeWork.image && howWeWork.image.asset && (
              <SanityImage
                alt={howWeWork.image.alt || 'Capextax'}
                fluid={howWeWork.image.asset.id}
              />
            )}
          </div>
          <div className="column is-6">
            <h1 className="title is-6 has-text-weight-bold has-text-orange">
              {howWeWork.title}
            </h1>
            <Heading dark size="is-2">
              {howWeWork.subtitle}
            </Heading>
            <Markdown className="is-6 pt-4">{howWeWork.description}</Markdown>
            {howWeWork.target && (
              <Link to={`/${howWeWork.target.slug.current}/`}>
                <Button fullWidth>
                  {howWeWork.buttonText || 'Learn more'}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default HowWeWork;
